import { render, staticRenderFns } from "./TheSnapshotTableQueries.vue?vue&type=template&id=07cbcc7e&"
import script from "./TheSnapshotTableQueries.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotTableQueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports